var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnalytic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_437_31737)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_437_31737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.77787 24.9133H10.8888C11.3183 24.9133 11.6667 25.2614 11.6667 25.6909V33.4688C11.6667 33.8983 11.3183 34.2466 10.8888 34.2466H7.77787C7.34835 34.2466 7 33.8983 7 33.4688V25.6909C7 25.2614 7.34835 24.9133 7.77787 24.9133Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5549 18.6909H18.6661C19.0957 18.6909 19.444 19.0392 19.444 19.4687V33.4688C19.444 33.8983 19.0957 34.2466 18.6661 34.2466H15.5549C15.1254 34.2466 14.7773 33.8983 14.7773 33.4688V19.4687C14.7773 19.0392 15.1254 18.6909 15.5549 18.6909Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3326 21.8021H26.4438C26.8733 21.8021 27.2214 22.1504 27.2214 22.58V33.4687C27.2214 33.8983 26.8733 34.2466 26.4438 34.2466H23.3326C22.903 34.2466 22.5547 33.8983 22.5547 33.4687V22.58C22.5547 22.1504 22.903 21.8021 23.3326 21.8021Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1119 17.1354H34.2228C34.6523 17.1354 35.0007 17.4838 35.0007 17.9133V33.4687C35.0007 33.8983 34.6523 34.2466 34.2228 34.2466H31.1119C30.6823 34.2466 30.334 33.8983 30.334 33.4687V17.9133C30.334 17.4838 30.6823 17.1354 31.1119 17.1354Z",
    fill: "#00994E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 7.80208C31.3787 7.80351 30.3348 8.84741 30.3333 10.1354C30.3365 10.3895 30.3815 10.6413 30.4666 10.8805L26.573 13.1951C26.062 12.653 25.3212 12.3904 24.5829 12.4893C23.8443 12.5881 23.1989 13.0364 22.8483 13.6938L19.4141 11.9928C19.4309 11.8928 19.4408 11.792 19.4445 11.6909C19.4462 10.7464 18.8786 9.89416 18.0064 9.53158C17.1343 9.16927 16.1297 9.36837 15.4618 10.036C14.7935 10.7037 14.5939 11.708 14.9559 12.5804L10.5011 15.9049C10.1479 15.6945 9.74463 15.5822 9.33333 15.58C8.04476 15.58 7 16.6244 7 17.9133C7 19.2019 8.04476 20.2466 9.33333 20.2466C10.6219 20.2466 11.6667 19.2019 11.6667 17.9133C11.6647 17.6324 11.6117 17.3547 11.5103 17.093L16.0095 13.7351C16.8896 14.2259 17.9873 14.082 18.7111 13.3808L22.6164 15.3151C22.8767 16.4746 23.9679 17.2528 25.1491 17.1212C26.3303 16.9896 27.2236 15.9907 27.2221 14.8021C27.2221 14.7428 27.209 14.687 27.2048 14.6289L31.4396 12.1113C31.8068 12.3434 32.232 12.4673 32.6667 12.4687C33.9552 12.4687 35 11.424 35 10.1354C35 8.84684 33.9552 7.80208 32.6667 7.80208Z",
    fill: "#00994E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_31737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_437_31737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytic);
export default __webpack_public_path__ + "static/media/analytic.ed2c51e80d9c39b56526d7462514ac6f.svg";
export { ForwardRef as ReactComponent };